export default {
  TitleFormName: 'Báo cáo nhanh',
  DatePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  GetData: 'Lấy dữ liệu',
  GroupButtonTitle: 'Nhóm theo cột',

  SaveForm: {
    Title: 'Lưu thành mẫu mới',
    InputLabel: 'Tên mẫu mới',
  },

  ListFrom: {
    Title: 'Danh sách mẫu báo cáo',
    
  }
};
